<template>
  <v-app>
    <v-content>
      <loadingcomp ref="loadingcomp" v-bind:mesaj="loadingmesaj" v-model="loadingdialog"></loadingcomp>

      <v-container fluid fill-height>

        <v-layout row wrap align-start="" justify-center>

          <v-flex xs12 v-if="this.payReturn.resultStatus=='SUCCESS'" sm12 m12>
            <v-layout row wrap justify-center>
              <v-flex xs12 sm12 m12>
                <v-layout justify-center>
                </v-layout>
              </v-flex>

              <v-flex xs12 pb-4 pt-4 sm12 m12>
                <v-layout justify-center>
                  <v-icon size="130" color="green">verified</v-icon>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 m12>
                <v-layout justify-center>
                  <span class="green--text title"> {{ $t('Your-payment-successfully-completed') }} </span>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-container fluid>
                  <v-layout justify-center row wrap>


                    <v-flex pa-1 xs12 sm4 md4>
                      <v-flex xs12 sm12 md12 pa-1>
                        <v-card flat="" class="black--text">
                          <v-layout>
                            <v-flex xs2 sm2 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <v-icon color="grey" large="">payments</v-icon>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm10 md11>

                              <v-card-title primary-title="">
                                  <v-flex xs12 sm12 md12>
                                  <v-layout>
                                    <v-flex xs12 sm3 md3>
                                      <v-list-tile-title>
                                        <span class="subtitle-1 font-weight-">
                                          {{ $t('Product-Description') }}
                                        </span>
                                      </v-list-tile-title>
                                    </v-flex>
                                    <v-flex xs12 sm9 md9>
                                      <v-list-tile-title>
                                        <span class="subtitle-1 font-weight-">
                                          : <span v-if="payReturn.value.PaketTip==1"> {{payReturn.value.UrunAciklama}} Paketi</span> <span v-if="payReturn.value.PaketTip==2" >{{payReturn.value.KontorAdet}} adet Kontör</span>
                                        </span>
                                      </v-list-tile-title>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout>
                                    <v-flex xs12 sm3 md3>
                                      <v-list-tile-title>
                                        <span class="subtitle-1 font-weight-">
                                          {{ $t('Payment-No') }}
                                        </span>
                                      </v-list-tile-title>
                                    </v-flex>
                                    <v-flex xs12 sm9 md9>
                                      <v-list-tile-title>
                                        <span class="subtitle-1 font-weight-">
                                          : {{payReturn.value.PaymentItemID}}
                                        </span>
                                      </v-list-tile-title>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider></v-divider>
                                </v-flex>


                                <v-flex xs12 sm12 md12>
                                  <v-layout>
                                    <v-flex xs12 sm3 md3>
                                      <v-list-tile-title>
                                        <span class="subtitle-1 font-weight-">
                                          {{ $t('Amount') }}
                                        </span>
                                      </v-list-tile-title>
                                    </v-flex>
                                    <v-flex xs12 sm9 md9>
                                      <v-list-tile-title>
                                        <span class="subtitle-1 font-weight-">
                                          : {{payReturn.value.PaymentAmount | moneyformat}} {{payReturn.value.Currency | getCurrency}}
                                        </span>
                                      </v-list-tile-title>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout>
                                    <v-flex xs12 sm3 md3>
                                      <v-list-tile-title>
                                        <span class="subtitle-1 font-weight-">
                                          <div class="font-weight- subtitle-1  black--text  mb-1">{{ $t('Octet-Payment-ID') }}</div>
                                        </span>
                                      </v-list-tile-title>
                                    </v-flex>
                                    <v-flex xs12 sm9 md9>
                                      <v-list-tile-title>
                                        <span class="subtitle-1 font-weight-">
                                          <div class="font-weight- subtitle-1  black--text  mb-1">:
                                            {{payReturn.value.OctetPaymentReferenceID}}</div>
                                        </span>
                                      </v-list-tile-title>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 pt-2 md12>
                                  <v-layout>

                                    <v-flex xs12 sm12 md12>
                                      <v-list-tile-title>
                                        <span class="subtitle-1 font-weight-">
                                          <div class="font-weight- subtitle-1  red--text  mb-1">
                                            {{ $t('Re-login-activate-settings-products-purchased') }}
                                          </div>
                                        </span>
                                      </v-list-tile-title>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider></v-divider>
                                </v-flex>




                              </v-card-title>
                            </v-flex>
                          </v-layout>

                        </v-card>
                      </v-flex>
                    </v-flex>




                  </v-layout>
                </v-container>
              </v-flex>


              <v-flex xs12 sm12 md6>
                <v-layout justify-end>
                  <v-btn @click="logOut()" outline color="red"> {{ $t('Login-v2') }} </v-btn>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-layout justify-start>
                  <v-btn @click="islemeDevamEt()" outline color="green"> {{ $t('Continue-the-process') }} </v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>



          <v-flex xs12 v-if="this.payReturn.resultStatus=='ERROR'" sm12 m12>
            <v-layout row wrap justify-center>
              <v-flex xs12 sm12 m12>
                <v-layout justify-center>
                </v-layout>
              </v-flex>

              <v-flex xs12 pb-4 pt-4 sm12 m12>
                <v-layout justify-center>
                  <v-icon size="130" color="red">cancel</v-icon>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 m12>
                <v-layout justify-center>
                  <span class="red--text title">{{ $t('error-occurred-your-payment-process') }} </span>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-container fluid>
                  <v-layout justify-center row wrap>


                    <v-flex pa-1 xs12 sm4 md4>
                      <v-flex xs12 sm12 md12 pa-1>
                        <v-card flat="" class="black--text">
                          <v-layout>
                            <v-flex xs2 sm2 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <v-icon color="grey" large="">new_releases</v-icon>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm10 md11>

                              <v-card-title primary-title="">

                                <v-flex xs12 sm12 md12>
                                  <v-layout>
                                    <v-flex xs12 sm3 md3>
                                      <v-list-tile-title>
                                        <span class="subtitle-1 font-weight-">
                                          {{ $t('Error-Code') }}
                                        </span>
                                      </v-list-tile-title>
                                    </v-flex>
                                    <v-flex xs12 sm9 md9>
                                      <v-list-tile-title>
                                        <span class="subtitle-1 font-weight-">
                                          : {{payReturn.resultCode}}
                                        </span>
                                      </v-list-tile-title>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider></v-divider>
                                </v-flex>


                                <v-flex xs12 sm12 md12>
                                  <v-layout>
                                    <v-flex xs12 sm3 md3>
                                      <v-list-tile-title>
                                        <span class="subtitle-1 font-weight-">
                                          {{ $t('Description') }}
                                        </span>
                                      </v-list-tile-title>
                                    </v-flex>
                                    <v-flex xs12 sm9 md9>
                                      <v-list-tile-title>
                                        <span class="subtitle-1 font-weight-">
                                          : {{payReturn.resultMessage}}
                                        </span>
                                      </v-list-tile-title>
                                    </v-flex>
                                  </v-layout>
                                  <v-divider></v-divider>
                                </v-flex>

                              </v-card-title>
                            </v-flex>
                          </v-layout>

                        </v-card>
                      </v-flex>
                    </v-flex>

                  </v-layout>
                </v-container>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-layout justify-center>
                  <v-btn @click="islemeDevamEt()" outline color="green"> {{ $t('Try-Again') }} </v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>

        </v-layout>

        <template>
          <v-card>
            <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
              :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"
              v-model="snackbar">
              {{ text1 }}
              <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
            </v-snackbar>
          </v-card>
        </template>

      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  import auth from '../../../api/auth'
  import _ from 'underscore'
  import router from '../../../router'
  import axios from 'axios'
  import helpers from "@/components/app/customcomp/helpers.js"
  import loadingcomp from "@/components/app/customcomp/loadingcomp.vue"

  import {
    Trans
  } from '@/plugins/Translation'

  export default {



    data() {
        return {
      loadingmesaj: null,
      loadingdialog: false,
      payReturn: {
        resultStatus: null,
        resultCode: null,
        resultMessage: null,
        value: {
          APIreferenceID: null,
          APIreferenceInfo: null,
          PaymentItemID: null,
          PaymentToSellerAmount: null,
          PaymentAmount: 0,
          Currency: null,
          PaymentType: null,
          PaymentAmount1:0,
          OctetPaymentReferenceID: null,
          MusteriID: null,
          PaketID: null,
          PaketTip: null,
          KontorAdet: null,
          UrunAciklama:null,
          InstallmentCount:0,
        }
      },
      MusteriUrun: {
        ID: null,
        MusteriID: null,
        PaketBilgi: {
          PaketID: null,
          PaketTip: null,
        },
        OdemeBilgi: {
          ID: null,
          OdemeTip: 0,
          OdemeOnay: false
        },
        BaslangicTarih: null,
        BitisTarihi: null,
        KontorAdet: 0,
        KalanKontorAdet: 0,
        BiletAdet: 0,
        FaturaAdet: 0,
        CariAdet: 0,
        IadeAdet: 0,
        VoidAdet: 0,
        CoperAdet: 0,
        CoperIptalAdet: 0,
        VizeAdet: 0,
      },
      UrunKayit: {
        ID: null,
        Aciklama: null,
        OdemeTip: '0', // 0 Havale 1 Kredi
        OdemeOnay: false,
        Tarih: null,
        Tutar: 0,
        Banka: null,
        TaksitAdet: null,
        VadeFarki: null,
        VadeTarihi: null,
        CariKod: null,
        FaturaTarihi: null,
        FaturaSeri: null,
        FaturaNo: null,
        IslemID: null,
        GuID: null,
        SiparisID: null,
        DekontID: null,
        UlkeID: null,
      },

      sifreyenileme: false,
      sifresifirlabekle: false,
      alerttype: 'error',
      confirmbekle: false,


      locale: 'tr',
      locales: [{
          locale: 'tr',
          title: 'Türkçe',
          href: 'turkey'
        },
        {
          locale: 'en',
          title: 'English',
          href: 'english'
        },
        {
          locale: 'de',
          title: 'Deutsch',
          href: 'germany'
        },
      ],
      Emailyeni: null,
      drawer: true,
      drawerRight: true,
      right: null,
      left: null,

      faturainfo: [],
      newuserstatus: true,
      loginstatus: true,
      drawer: null,
      e1: 0,
      e2: true,
      e3: true,
      e4: true,
      text1: '',
      snackbar: false,
      y: 'top',
      x: 'right',
      mode: '',
      bekle: false,
      timeout: 6000,
      rules: {
        required: (value) => !!value || this.$t('Mandatory-Areas'),
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || this.$t('Wrong-e-mail')
        }
      },
      Kullanici: {
        Email: null,
        Sifre: '',
        SifreConfirm: '',
        Token: null
      },
      unvan: null,
      confirm: null,
      Credential: {
        email: '',
        password: ''
      },
      valid: true,
      errorMsg: '',
      errorAlert: false,
      yenierrorMsg: '',
      yenierrorAlert: false,
      AnaSirketler: [],
      Sirketler: [],
      AnaSirket: {},
      Sirket: {}
      }
    },
    props: {
      source: String
    },

    methods: {


      islemeDevamEt() {
        var url = '#/account/urunler/id'
        window.open(url, '_self')
      },
      logOut() {
        auth.logout()
      },

      changeLanguage(e) {
        const lang = e
        const to = this.$router.resolve({
          params: {
            lang
          }
        })
        return Trans.changeLanguage(lang).then(() => {
          this.$router.push(to.location)
          this.locale = e
        })
      },
      getImgUrl(pet) {
        var images = require.context('../../../assets/images', false, /\.png$/)
        return images('./' + pet + ".png")
      },
      apiLogin,
      sysLogin,
      anaSirketIleri,
      newUser,
      geriDon,
      saveUser,
      epostagonder,
    },
    beforeMount: beforeMount,
    components: {
      loadingcomp
    },
    mounted() {

      this.payReturn.resultStatus = this.$route.query.resultStatus
      this.payReturn.resultCode = this.$route.query.resultCode
      this.payReturn.resultMessage = this.$route.query.resultMessage
      this.payReturn.value.APIreferenceID = this.$route.query.APIreferenceID
      this.payReturn.value.APIreferenceInfo = this.$route.query.APIreferenceInfo
      this.payReturn.value.PaymentItemID = this.$route.query.PaymentItemID
      this.payReturn.value.PaymentToSellerAmount = this.$route.query.PaymentToSellerAmount
      this.payReturn.value.PaymentAmount = parseFloat(this.$route.query.PaymentAmount.replace(',','.').replace(' ',''))
      this.payReturn.value.Currency = this.$route.query.Currency
      this.payReturn.value.PaymentType = this.$route.query.PaymentType
      this.payReturn.value.OctetPaymentReferenceID = this.$route.query.OctetPaymentReferenceID

      this.payReturn.value.MusteriID = this.$route.query.MusteriId
      this.payReturn.value.PaketID = this.$route.query.PaketId
      this.payReturn.value.PaketTip = this.$route.query.PaketTip
      this.payReturn.value.KontorAdet = this.$route.query.KontorAdet
      this.payReturn.value.UrunAciklama = this.$route.query.UrunAciklama
this.payReturn.value.InstallmentCount=this.$route.query.InstallmentCount


      if (this.payReturn.resultStatus == 'SUCCESS') {
        this.loadingdialog = true
        this.UrunKayit.Tarih = helpers.getDateNow()
        this.UrunKayit.OdemeOnay = true
        this.UrunKayit.Aciklama = 'OCT'+this.payReturn.value.OctetPaymentReferenceID
        this.UrunKayit.OdemeTip=1
        this.UrunKayit.Tutar= this.payReturn.value.PaymentAmount
        this.UrunKayit.TaksitAdet=this.payReturn.value.InstallmentCount

        var manageload = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));

        var index = manageload.AnaSirketInfo.findIndex(p => p.MusteriID == this.payReturn.value.MusteriID)

        this.UrunKayit.UlkeID = manageload.AnaSirketInfo[index].UlkeID

        var params = this.UrunKayit

        this.$http.post(auth.API_URL + 'api/Register/PackageCustomerPaymentSave', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          if (response.body.Status == true) {

            this.MusteriUrun.MusteriID = this.payReturn.value.MusteriID
            this.MusteriUrun.PaketBilgi.PaketTip = this.payReturn.value.PaketTip
            this.MusteriUrun.PaketBilgi.PaketID=this.payReturn.value.PaketID
            this.MusteriUrun.OdemeBilgi.ID = response.body.SaveID
            this.MusteriUrun.OdemeBilgi.OdemeTip = "1"
            this.MusteriUrun.OdemeBilgi.OdemeOnay = true
            this.MusteriUrun.OdemeBilgi.UlkeID = this.UrunKayit.UlkeID

            if (this.MusteriUrun.PaketBilgi.PaketTip == 2) {
              this.MusteriUrun.KontorAdet = this.payReturn.value.KontorAdet
              this.MusteriUrun.KalanKontorAdet = this.payReturn.value.KontorAdet
              this.MusteriUrun.BaslangicTarih = helpers.getDateNow()
              this.MusteriUrun.BitisTarihi = helpers.getDateNow()
            } else {
              this.MusteriUrun.KontorAdet = 0
              this.MusteriUrun.KalanKontorAdet = 0
              this.MusteriUrun.BaslangicTarih = null
              this.MusteriUrun.BitisTarihi = null
            }
            var params = this.MusteriUrun


            this.$http.post(auth.API_URL + 'api/Register/PackageCustomerSave',
              params, {
                headers: {
                  'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
              }).then((response) => {
              this.loadingdialog = false

              if (response.body.Status == true) {} else {
                this.text1 = this.$t('Payment-completed-has-presented-your-user-Please-reach-support-team')
                this.snackbar = true
              }
            }, (response) => {
              this.loadingdialog = false

              if (response.status === 0) {
                this.text1 = this.$t('Payment-completed-has-presented-your-user-Please-reach-support-team')
                this.snackbar = true
              } else {
                this.text1 = this.$t('Payment-completed-has-presented-your-user-Please-reach-support-team')
                this.snackbar = true
              }
            })

          } else {
            this.text1 = this.$t('Payment-completed-has-presented-your-user-Please-reach-support-team')
            this.snackbar = true
            this.loadingdialog = false
          }


        }, (response) => {
          if (response.status === 0) {
            this.text1 = this.$t('Payment-completed-has-presented-your-user-Please-reach-support-team')
            this.snackbar = true
            this.loadingdialog = false


          } else {
            this.loadingdialog = false
            this.text1 = this.$t('Payment-completed-has-presented-your-user-Please-reach-support-team')
            this.snackbar = true
          }
        })
      } 




    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      timeformat: function (t) {
        return helpers.getTime(t)
      },
      getCurrency: function (t) {
        return helpers.getparabirimiDefault(t)
      }
    },
  }



  function beforeMount(e) {


  }



  function epostagonder(kime, token) {

    var okMail = auth.URL_MAIL + 'isl=confirmmail&token=' + token



    let formData = new FormData();

    formData.append('Konu', 'E-Posta Onay Maili')
    formData.append('to', kime)
    formData.append('mailType', '0')
    var okMail = auth.URL_MAIL + 'isl=confirmmail&token=' + token + this.$t('approve-your-mail-from-url-address')
    formData.append('formattedMessage', okMail)

    axios.defaults.baseURL = auth.API_URL;
    // axios.responseType = 'arraybuffer';
    axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
    axios.post(auth.API_URL + 'api/Helpers/SendEmail',
        formData, {
          headers: {

          }
        }
      ).then((response) => {

        if (response.data == true) {
          this.text1 = this.$t('Approval-mail-sent-registered-system-approving-your-mail')
          this.snackbar = true
        } else {
          this.text1 = this.$t('user-record-created-approval-been-sent-mail')
          this.snackbar = true
        }
      })
      .catch(function () {});



  }

  function saveUser() {
    if (this.$refs.formnewuserstatus.validate()) {
      if (this.YeniKullanici.Sifre == this.confirm) {

        this.Emailyeni = this.YeniKullanici.email
        var musteribilgi = {
          Ad: this.unvan
        }
        var musteribilgiler = [];
        musteribilgiler.push(musteribilgi)
        this.YeniKullanici.MusteriBilgi = musteribilgiler
        var params1 = this.YeniKullanici;

        this.$http.post(auth.API_URL + 'api/Register/Create', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          if (response.body.Status == true) {

            this.epostagonder(this.Emailyeni, response.body.UserToken)

            // this.errorMsg = 'Kayıt işlemi gerçekleşti. Giriş yapınız..';
            //this.errorAlert = true;
            this.newuserstatus = false;
            this.loginstatus = true;

          } else {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true;
          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-' + this.$t('New-User')
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-' + this.$t('New-User')
            this.snackbar = true
          }
        })


      } else {
        this.errorMsg = this.$t('Passwords-do-not-match')
        this.errorAlert = true;
      }

    } else {

    }
  }

  function geriDon() {
    this.newuserstatus = false;
    this.loginstatus = true;
  }

  function newUser() {
    this.newuserstatus = true;
    this.loginstatus = false;
  }

  function apiLogin() {
    this.bekle = true;
    var credential = {
      Email: this.Credential.email,
      Password: this.Credential.password
    }
    auth.login(this, credential, this.$route.query.redirect)

  }

  function sysLogin() {
    ('syslogine girdi')
    var earsiv = 0
    var efatura = 0
    var response = JSON.parse(window.localStorage.getItem('response'));
    var sirketler = JSON.parse(window.localStorage.getItem('sirketler'));
    window.localStorage.setItem('token', response.Token.token);

    var sirketparams = {
      SirketKodu: this.Sirket.id
    }
    this.$http.post(auth.API_URL + 'api/Parameters/CompanyGet', sirketparams, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {


      earsiv = response.body.OpsiyonBilgileri.EArsiv
      efatura = response.body.OpsiyonBilgileri.EFaturaKullaniyor

      var credentials = {
        AnaSirketKodu: this.AnaSirket.id,
        SirketKodu: this.Sirket.id,
        SirketAdi: this.Sirket.text,
        SirketUnvani: this.Sirket.unvan,
        Sirketler: sirketler,
        EArsiv: earsiv,
        EFatura: efatura,
        CoperSirketNo: 0,
      }


      window.localStorage.setItem('credentials', JSON.stringify(credentials));



    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Company Get'
        this.snackbar = true
        this.load1 = true
        this.progress = false

        var credentials = {
          AnaSirketKodu: this.AnaSirket.id,
          SirketKodu: this.Sirket.id,
          SirketAdi: this.Sirket.text,
          SirketUnvani: this.Sirket.unvan,
          Sirketler: sirketler,
          EArsiv: earsiv,
          EFatura: efatura,
          CoperSirketNo: 0,
        }

        window.localStorage.setItem('credentials', JSON.stringify(credentials));
      } else {
        this.text1 = 'Service Unavailable-Company Get'
        this.snackbar = true
        this.load1 = true
        this.progress = false
        var credentials = {
          AnaSirketKodu: this.AnaSirket.id,
          SirketKodu: this.Sirket.id,
          SirketAdi: this.Sirket.text,
          SirketUnvani: this.Sirket.unvan,
          Sirketler: sirketler,
          EArsiv: earsiv,
          EFatura: efatura,
          CoperSirketNo: 0,
        }
        window.localStorage.setItem('credentials', JSON.stringify(credentials));
      }
    })

    window.localStorage.removeItem('response')
    window.localStorage.removeItem('sirketler')

    router.push({
      path: '/'
    })
  }

  function anaSirketIleri() {
    var response = JSON.parse(window.localStorage.getItem('response'));

    var anaSirketBilgiler = _.findWhere(response.MusteriDbler, {
      MusteriKod: this.AnaSirket.id
    })

    if (anaSirketBilgiler.GenelSirketler.length === 0) {
      this.errorAlert = true;
      this.errorMsg = this.$t('Registered-corporations-are-not-found')
      this.e1 = 2;
    } else {
      this.errorAlert = false;
      this.e1 = 3;

      var sirketler = [];

      Object.keys(anaSirketBilgiler.GenelSirketler).forEach(key => {
        var sirket = {
          text: anaSirketBilgiler.GenelSirketler[key].SirketAdi,
          id: anaSirketBilgiler.GenelSirketler[key].SirketKodu,
          unvan: anaSirketBilgiler.GenelSirketler[key].SirketUnvani
        }
        sirketler.push(sirket)
      });
      window.localStorage.setItem('sirketler', JSON.stringify(sirketler));
      this.Sirketler = sirketler;
      this.Sirket = sirketler[0];

    }

  }
</script>